<template>
  <div id="app">
    <RouterView />
  </div>
</template>
<script setup>
import RouterView from './router/RouterView.vue';
// import ModelList from './pages/ModelList.vue';
// import Metaverse from './pages/Metaverse.vue';
// import ChunkedLoading from './pages/ChunkedLoading.vue';

// import { ref, onMounted } from 'vue';
// const curHash = ref(window.location.hash);
// onMounted(async () => {
//   console.log('window.location.hash=', window.location.hash);
//   // 监听 hash 中 modelUrl 的变化并刷新页面
//   let currentModelUrl = null;

//   // 从 hash 中提取 modelUrl 参数
//   function getModelUrlFromHash() {
//     const hash = window.location.hash;
//     console.log('hash===', hash);
//     if (hash) {
//       curHash.value = hash.split('?')[0];
//     }
//     const urlParams = new URLSearchParams(hash.split('?')[1] || '');
//     return urlParams.get('modelUrl');
//   }

//   // 初始化当前 modelUrl
//   currentModelUrl = getModelUrlFromHash();

//   // 监听 hashchange 事件
//   window.addEventListener('hashchange', function () {
//     console.log('hashchange==');
//     const newModelUrl = getModelUrlFromHash();
//     console.log('hashchange newModelUrl', newModelUrl);
//     // 如果 modelUrl 发生了变化，刷新页面
//     console.log('hashchange currentModelUrl', currentModelUrl);
//     if (currentModelUrl !== newModelUrl && newModelUrl !== null) {
//       console.log('ModelUrl changed from', currentModelUrl, 'to', newModelUrl, '- reloading page');
//       window.location.reload();
//     }
//     if (newModelUrl === null && currentModelUrl === null) {
//       window.location.reload();
//     }
//     currentModelUrl = newModelUrl;
//   });
// });
</script>
<style scoped>
#app {
  overscroll-behavior-y: none;
  width: 100vw;
  height: 100%;
  /* height: 100vh; */
}
</style>
